import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { registerUser, loginUser } from "../../services/api";
import { checkAuth } from "../../services/api";
import { logoutUser } from "../../services/api";

// ─── Register ────────────────────────────────────────────────────────
export const fetchRegister = createAsyncThunk(
    "auth/fetchRegister",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await registerUser(formData);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Registration failed"
            );
        }
    }
);

// ─── Login ───────────────────────────────────────────────────────────
export const fetchLogin = createAsyncThunk(
    "auth/fetchLogin",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await loginUser(formData);
            // console.log(response.data)
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Login failed"
            );
        }
    }
);

//checkAuth

export const fetchCheckAuth = createAsyncThunk(
    "auth/fetchCheckAuth",
    async (_, { rejectWithValue }) => {
        try {
            const response = await checkAuth();
            return response.data; // { id... }
        } catch {
            return rejectWithValue("Not logged in");
        }
    }
);

//logout
export const fetchLogout = createAsyncThunk(
    "auth/fetchLogout",
    async (_, { rejectWithValue }) => {
        try {
            const response = await logoutUser();
            return response.data;
        } catch (error) {
            return rejectWithValue("Logout failed");
        }
    }
);
const authSlice = createSlice({
    name: "auth",
    initialState: {
        user: null,
        loading: false,
        authChecked: false,
        error: null,
        success: null,
    },
    reducers: {
        // ✅ call this on logout
        clearAuth: (state) => {
            state.user = null;
            state.error = null;
            state.success = null;
        },
        clearMessages: (state) => {
            state.error = null;
            state.success = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // ── Register ──
            .addCase(fetchRegister.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = null;
            })
            .addCase(fetchRegister.fulfilled, (state, action) => {
                state.loading = false;
                state.success = action.payload.message; // "Sign up successful"
            })
            .addCase(fetchRegister.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // ── Login ──
            .addCase(fetchLogin.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = null;
            })
            .addCase(fetchLogin.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload.details; // { id, userId, f_name, email_address }                
                state.success = "Login successful"; state.user = {
                    userId: action.payload.details.userId,
                    username: action.payload.details.f_name,
                };
            })
            .addCase(fetchLogin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            //checkAuth
            .addCase(fetchCheckAuth.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchCheckAuth.fulfilled, (state, action) => {
                state.loading = false;
                state.authChecked = true;
                state.user = action.payload; // { id, username, userId }
            })
            .addCase(fetchCheckAuth.rejected, (state) => {
                state.loading = false;
                state.authChecked = true;
                state.user = null;
            })
            .addCase(fetchLogout.fulfilled, (state) => {
                state.user = null;
                state.authChecked = true;
                state.success = null;
                state.error = null;
            })
            .addCase(fetchLogout.rejected, (state, action) => {
                state.error = action.payload;
            })
    },
});

export const { clearAuth, clearMessages } = authSlice.actions;
export default authSlice.reducer;